import React from 'react';
import * as Icons from 'lucide-react';
import { CheckCircle2, ExternalLink, ShieldCheck } from 'lucide-react';
import { LICENSES } from '../mock';

const LicensesSection = ({ compact = false }) => {
  return (
    <section className={`${compact ? 'py-16' : 'section'} bg-white`}>
      <div className="container-xl">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <div className="inline-flex items-center gap-2 bg-green-50 text-green-700 px-3 py-1 rounded-full text-xs font-bold tracking-wider uppercase mb-3">
            <ShieldCheck className="w-3.5 h-3.5" /> Registration & insurance
          </div>
          <h2 className="font-display text-4xl md:text-5xl font-extrabold text-[color:var(--mv-navy)]">
            Fully Licensed &amp; Insured
          </h2>
          <p className="text-slate-600 mt-4">
            Our waste carrier registration can be checked on the Environment Agency public register. Insurance cover applies subject to policy limits and exclusions — ask us for details.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {LICENSES.map((l) => {
            const Icon = Icons[l.icon] || ShieldCheck;
            return (
              <article key={l.id} className="relative rounded-xl border border-slate-200 bg-white p-6 hover:border-[color:var(--mv-orange)] hover:shadow-[0_20px_40px_-24px_rgba(11,37,69,0.3)] transition-all">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 shrink-0 rounded-md bg-[color:var(--mv-navy)] text-white flex items-center justify-center">
                    <Icon className="w-5 h-5" />
                  </div>
                  <div className="min-w-0 flex-1">
                    <div className="flex items-start justify-between gap-3 flex-wrap">
                      <div>
                        <div className="text-xs font-bold tracking-wider uppercase text-[color:var(--mv-orange)]">{l.issuer}</div>
                        <h3 className="font-display text-xl font-extrabold text-[color:var(--mv-navy)] mt-0.5">{l.title}</h3>
                      </div>
                      <span className="inline-flex items-center gap-1 bg-green-50 text-green-700 border border-green-200 px-2.5 py-1 rounded-full text-[11px] font-bold uppercase tracking-wider shrink-0">
                        <CheckCircle2 className="w-3 h-3" /> {l.status}
                      </span>
                    </div>
                    <div className="mt-2 inline-block bg-slate-50 border border-slate-200 rounded-md px-3 py-1 font-mono text-sm font-bold text-[color:var(--mv-navy)]">
                      {l.reg}
                    </div>
                    <p className="text-slate-600 text-sm leading-relaxed mt-3">{l.description}</p>
                    <div className="mt-4 grid grid-cols-2 gap-3 text-xs">
                      <div>
                        <div className="text-slate-400 uppercase tracking-wider font-semibold">Role</div>
                        <div className="text-slate-700 font-semibold mt-0.5">{l.role}</div>
                      </div>
                      <div>
                        <div className="text-slate-400 uppercase tracking-wider font-semibold">Valid until</div>
                        <div className="text-slate-700 font-semibold mt-0.5">{l.expires}</div>
                      </div>
                    </div>
                    {l.docUrl && l.docOk && (
                      <a href={l.docUrl} target="_blank" rel="noreferrer" className="mt-4 inline-flex items-center gap-1.5 text-sm font-bold text-[color:var(--mv-orange)] hover:gap-2 transition-all">
                        View certificate <ExternalLink className="w-3.5 h-3.5" />
                      </a>
                    )}
                  </div>
                </div>
              </article>
            );
          })}
        </div>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-x-8 gap-y-3 text-xs text-slate-500">
          <span className="flex items-center gap-2"><CheckCircle2 className="w-4 h-4 text-green-600" /> Environment Agency registered</span>
          <span className="flex items-center gap-2"><CheckCircle2 className="w-4 h-4 text-green-600" /> Goods-in-transit £10k</span>
          <span className="flex items-center gap-2"><CheckCircle2 className="w-4 h-4 text-green-600" /> Public liability £1m</span>
          <span className="flex items-center gap-2"><CheckCircle2 className="w-4 h-4 text-green-600" /> UK Companies House registered</span>
        </div>
      </div>
    </section>
  );
};

export default LicensesSection;
